
import { defineComponent, PropType } from "vue";
import { Stunt } from "@/types";
import { ModalWindow } from "@/shared/ui";
import { AddNewAndEditStunt } from "@/features";

export default defineComponent({
	name: "Stunt",
	components: { AddNewAndEditStunt, ModalWindow },
	emits: ["update", "remove"],
	props: {
		stunt: {
			type: Object as PropType<Stunt>,
			required: true,
		},
	},
	data() {
		return {
			modal: false,
		};
	},
	methods: {
		update(stunt: Stunt) {
			this.$emit("update", stunt);
		},
		remove() {
			this.$emit("remove");
		},
	},
});
